import {
    ExternalPayoutStatus,
    IPayment,
    PAYOUTSTATUS
} from "@shared/lib/types/briefCampains";
import styles from "./paymentExternalStatus.module.scss";

type PaymentStatusProps = {
  record: IPayment;
};

function getStatusLabel(record: IPayment): string {
      if (record.externalPayoutStatus === ExternalPayoutStatus.Failed) return "Failed";
  if (record.externalPayoutStatus === ExternalPayoutStatus.Cancelled) return "Cancelled";
  if (record.payoutStatus === PAYOUTSTATUS.Success) return "Paid";
  return record.payoutStatus || "—";
}

function getStatusTone(
  status?: PAYOUTSTATUS | string
): "pending" | "success" | "failed" | "cancelled" {
  switch (status) {
    case PAYOUTSTATUS.Success:
      return "success";
    case PAYOUTSTATUS.Failed:
      return "failed";
    case ExternalPayoutStatus.Cancelled:
        return "cancelled";
    default:
      return "pending";
  }
}

export function PaymentStatus({ record }: PaymentStatusProps) {
  const externalStatus = record.externalPayoutStatus;
  const status = record.payoutStatus;
  const tone = getStatusTone(status);
  const reason = record.externalPayoutRejectionReason;

  return (
    <div className={styles.cell}>
      <span className={`${styles.pill} ${styles[tone]}`}>
        {getStatusLabel(record)}
      </span>
      {externalStatus === ExternalPayoutStatus.Failed && reason ? (
        <div className={styles.reason}>{reason}</div>
      ) : null}
      {externalStatus === ExternalPayoutStatus.Cancelled && reason ? (
        <div className={styles.reason}>{reason}</div>
      ) : null}
    </div>
  );
}
